/**
 * Daftar "OPEN PO" untuk popup Buat Memo pada satu tanggal.
 * Satu entri jadwal = { date, jumlah, isKirim, isBuatMemo, ... }.
 *
 * Normalnya: entri isKirim yang belum isBuatMemo dan jumlah > 0.
 * Pengaman: kalau di tanggal itu ada entri NEGATIF (sisa dari kirimPO yang mengurangi entri
 * yang salah), jumlah yang terbuka dihitung bersih supaya barang yang sudah dibuat memo
 * tidak muncul lagi dan tidak bisa dibuat memo dua kali.
 */
export const buildOpenMemoItems = (dataListPo, dateMemoKirim) => {
  const out = [];

  (dataListPo || []).forEach((element) => {
    const jadwal = element.jadwalKirim || [];
    if (jadwal.length === 0) return;

    const day = jadwal.filter(
      (e) => e.date === dateMemoKirim && e.isKirim === true && !e.isBatal
    );
    const hasNegative = day.some((e) => Number(e.jumlah) < 0);
    let openLeft = day
      .filter((e) => e.isBuatMemo !== true || Number(e.jumlah) < 0)
      .reduce((s, e) => s + Number(e.jumlah), 0);

    jadwal.forEach((ele) => {
      if (
        !ele.isBatal &&
        ele.jumlah > 0 &&
        ele.date === dateMemoKirim &&
        ele.isBuatMemo !== true &&
        ele.isKirim === true
      ) {
        let jumlah = ele.jumlah;
        if (hasNegative) {
          if (openLeft <= 0) return;
          jumlah = Math.min(ele.jumlah, openLeft);
          openLeft -= jumlah;
        }
        out.push({
          id: element.id,
          customer: element.customer,
          itemPo: element.itemPo,
          kodeBarang: element.kodeBarang,
          noPo: element.noPo,
          isKirim: ele.isKirim,
          isMaju: ele.isMaju,
          isMundur: ele.isMundur,
          isBatal: ele.isBatal,
          isBuatMemo: ele.isBuatMemo,
          jumlah,
          date: ele.date,
        });
      }
    });
  });

  return out;
};
